import { useCallback } from "react";
import { Edge, Node } from "@xyflow/react";
import { useAtomValue, useSetAtom } from "jotai";
import { edgesAtom, saveCanvasAsyncCommand } from "@zapier/canvas-state";

import { useDeleteNodes } from "../../hooks/useDeleteNodes";

export function useDeleteCallbacks() {
  const edges = useAtomValue(edgesAtom);
  const { onNodesDelete } = useDeleteNodes();
  const saveToBackend = useSetAtom(saveCanvasAsyncCommand);

  const onNodeDeleteFromContextMenu = useCallback(
    (nodeToBeDeleted: Node) => {
      onNodesDelete([nodeToBeDeleted]);
    },
    [onNodesDelete],
  );

  const onNodeDeleteFromKeyboard = useCallback(
    (nodesDeleted: Node[]) => {
      /** onNodesChange is called before onNodesDelete and updates the RF state already, but we setNodes again since we're doing some manual path node deletion and connection.
       * When a path node has only 1 branch, we remove the path node.
       * */
      onNodesDelete(nodesDeleted);
    },
    [onNodesDelete],
  );

  const onEdgesDeleteFromKeyboard = useCallback(
    async (edgesDeleted: Edge[]) => {
      const deletedEdgesIds = edgesDeleted.map((edge) => edge.id);
      const remainingEdges = edges.filter(
        (edge) => !deletedEdgesIds.includes(edge.id),
      );

      saveToBackend({ edges: remainingEdges });
    },
    [edges, saveToBackend],
  );

  return {
    onNodeDeleteFromContextMenu,
    onNodeDeleteFromKeyboard,
    onEdgesDeleteFromKeyboard,
  };
}
